/**
 * 图片挖空题
 */
import QuestionHollow from './view';
import './index.less';

export default QuestionHollow;



// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/hollow/index.js